exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addlist[data-v-47b7a8e6]{margin-top:20px;padding-right:20px;padding-left:20px}.addlist ol[data-v-47b7a8e6]{display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:0}.addlist ol li[data-v-47b7a8e6]{width:49%;margin-left:20px}.addlist ol li[data-v-47b7a8e6]:nth-child(1){margin-left:0}.addlist ul[data-v-47b7a8e6]{padding-right:20px}.addlist ul li[data-v-47b7a8e6]{width:100%}.addlist .el-scrollbar__wrap .el-select-dropdown__item span[data-v-47b7a8e6]{display:inline-block;width:270px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n", ""]);

// exports
